<template>
    <div class="container mb-8 mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">{{ __('Alapterv') }}</h1>

        <c-control-select class="mx-auto w-96" class-field="bg-white" name="group"
                          v-bind:label="__('Felhasználói csoport')"
                          v-bind:options="groups"
                          v-model="group"
        />
    </div>

    <div class="mx-auto px-2 w-full">
        <div class="bg-slate-800 flex flex-col mb-8 md:flex-row md:items-center px-4 py-1 text-white">
            <span class="font-bold mb-4 md:mb-0 md:mr-8 text-lg">{{ __('Műveletek') }}:</span>

            <div class="flex items-center mb-2 md:mb-0">
                <span class="mr-2 text-sm">{{ __('Másolás innen') }}:</span>
                <c-control-select class="!mb-0 mr-2 w-48" name="group"
                                  v-bind:options="groupsExceptCurrent"
                                  v-model="groupBase"
                />
                <a class="bg-white cursor-pointer hover:bg-highlight hover:text-white lg:mr-2 px-2 py-1 text-slate-800 text-sm"
                   v-on:click="copyFromBase"
                >
                    {{ __('Másol') }}
                </a>
            </div>
        </div>
    </div>

    <div class="bg-white px-2 w-full" v-if="group && products">
        <div class="bg-highlight flex items-center justify-between md:justify-center px-2 py-4 sticky text-white top-[var(--banner-offset)] z-30">
            <a class="cursor-pointer flex items-center md:hidden text-lg text-white uppercase"
               v-on:click="prevDay"
            >
                <c-icon class="h-6 mr-2 stroke-white w-6" icon="chevron-left" />
                <span>{{ __('Előző') }}</span>
            </a>
            <span class="font-serif hidden text-3xl xl:inline text-center">
                {{ __('Alapterv') }} <span class="font-sans text-base">({{ groupLabel}})</span>
            </span>
            <a class="cursor-pointer flex items-center md:hidden text-lg text-white uppercase"
               v-on:click="nextDay"
            >
                <span>{{ __('Következő') }}</span>
                <c-icon class="h-6 ml-2 stroke-white w-6" icon="chevron-right" />
            </a>
        </div>
        <div class="bg-white border-b border-b-slate-100 grid grid-cols-5 font-semibold px-2 sticky text-center top-[calc(4rem+var(--banner-offset))] xl:grid-cols-10 z-30">
            <span class="flex items-center justify-center p-4"></span>
            <span class="border-l col-span-2 flex items-center justify-center p-4 xl:col-span-3">
                {{ __('Termék') }}
            </span>
            <span class="border-l hidden items-center justify-center p-4 xl:flex">
                {{ __('Ár') }}
            </span>
            <span class="border-l col-span-2 hidden p-4 xl:col-span-1 xl:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'monday' }"
            >
                {{ __('Hétfő') }}<br />
                <a class="cursor-pointer font-normal text-xs" v-on:click="resetAvailabilityData('monday')">
                    ❌ {{ __('Nullázás') }}
                </a>
            </span>
            <span class="border-l col-span-2 hidden p-4 xl:col-span-1 xl:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'tuesday' }"
            >
                {{ __('Kedd') }}<br />
                <a class="cursor-pointer font-normal text-xs" v-on:click="resetAvailabilityData('tuesday')">
                    ❌ {{ __('Nullázás') }}
                </a>
            </span>
            <span class="border-l col-span-2 hidden p-4 xl:col-span-1 xl:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'wednesday' }"
            >
                {{ __('Szerda') }}<br />
                <a class="cursor-pointer font-normal text-xs" v-on:click="resetAvailabilityData('wednesday')">
                    ❌ {{ __('Nullázás') }}
                </a>
            </span>
            <span class="border-l col-span-2 hidden p-4 xl:col-span-1 xl:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'thursday' }"
            >
                {{ __('Csütörtök') }}<br />
                <a class="cursor-pointer font-normal text-xs" v-on:click="resetAvailabilityData('thursday')">
                    ❌ {{ __('Nullázás') }}
                </a>
            </span>
            <span class="border-l col-span-2 hidden p-4 xl:col-span-1 xl:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'friday' }"
            >
                {{ __('Péntek') }}<br />
                <a class="cursor-pointer font-normal text-xs" v-on:click="resetAvailabilityData('friday')">
                    ❌ {{ __('Nullázás') }}
                </a>
            </span>
        </div>
        <div v-for="product in products">
            <div class="border-t grid grid-cols-5 px-2 xl:grid-cols-10"
                 v-if="product.base[`${group}`] && product.base[`${group}`]"
            >
                <span class="flex items-center justify-center p-1">
                    <img class="max-w-32 w-full" v-bind:alt="product.name" v-bind:src="product.picture" />
                </span>
                <span class="border-l col-span-2 flex flex-col items-start justify-center p-4 xl:col-span-3">
                    <strong class="block text-slate-800 text-sm">{{ product.name }}</strong>
                    <span class="mt-1 text-slate-500 text-xs">{{ product.description }}</span>

                    <div class="flex flex-col xl:hidden">
                        <span class="mt-4">
                            {{ currencyStore.format(product.prices[`${group}`], 'huf') }}
                        </span>
                        <span class="text-xs">
                            ({{ currencyStore.format(product.prices[`${group}`] / (1 + product.vat_pct / 100), 'huf') }} + {{ __('ÁFA') }})
                        </span>
                    </div>
                </span>
                <span class="border-l hidden items-center justify-center p-4 text-center xl:flex">
                    <div class="flex flex-col">
                        <span>  
                            {{ currencyStore.format(product.prices[`${group}`], 'huf') }}
                        </span>
                        <span class="text-xs">
                            ({{ currencyStore.format(product.prices[`${group}`] / (1 + product.vat_pct / 100), 'huf') }} + {{ __('ÁFA') }})
                        </span>
                    </div>
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 xl:col-span-1 xl:flex"
                      v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'monday' }"
                >
                    <c-control-number class="w-20" class-field="!bg-slate-800 !text-white" pattern="\d*"
                                      v-bind:label="__('Összesen')"
                                      v-bind:min="1"
                                      v-bind:name="product.id + '.' + group + '.monday.total'"
                                      v-bind:step="1"
                                      v-model.number="product.base[`${group}`].monday.total"
                                      v-on:update:model-value="updateTotalAvailability(product, group, 'monday')"
                    />
                    <c-control-number class="mt-4 w-20" class-field="!bg-slate-800 !text-white" pattern="\d*"
                                      v-bind:label="__('Vásárlónként')"
                                      v-bind:max="product.base[`${group}`].monday.total"
                                      v-bind:min="1"
                                      v-bind:name="product.id + '.' + group + '.monday.perPerson'"
                                      v-bind:step="1"
                                      v-model.number="product.base[`${group}`].monday.perPerson"
                                      v-on:update:model-value="checkMaxPerPerson(product, group, 'monday')"
                    />
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 xl:col-span-1 xl:flex"
                      v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'tuesday' }"
                >
                    <c-control-number class="w-20" class-field="!bg-slate-800 !text-white" pattern="\d*"
                                      v-bind:label="__('Összesen')"
                                      v-bind:min="1"
                                      v-bind:name="product.id + '.' + group + '.tuesday.total'"
                                      v-bind:step="1"
                                      v-model.number="product.base[`${group}`].tuesday.total"
                                      v-on:update:model-value="updateTotalAvailability(product, group, 'tuesday')"
                    />
                    <c-control-number class="mt-4 w-20" class-field="!bg-slate-800 !text-white" pattern="\d*"
                                      v-bind:label="__('Vásárlónként')"
                                      v-bind:max="product.base[`${group}`].tuesday.total"
                                      v-bind:min="1"
                                      v-bind:name="product.id + '.' + group + '.tuesday.perPerson'"
                                      v-bind:step="1"
                                      v-model.number="product.base[`${group}`].tuesday.perPerson"
                                      v-on:update:model-value="checkMaxPerPerson(product, group, 'tuesday')"
                    />
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 xl:col-span-1 xl:flex"
                      v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'wednesday' }"
                >
                    <c-control-number class="w-20" class-field="!bg-slate-800 !text-white" pattern="\d*"
                                      v-bind:label="__('Összesen')"
                                      v-bind:min="1"
                                      v-bind:name="product.id + '.' + group + '.wednesday.total'"
                                      v-bind:step="1"
                                      v-model.number="product.base[`${group}`].wednesday.total"
                                      v-on:update:model-value="updateTotalAvailability(product, group, 'wednesday')"
                    />
                    <c-control-number class="mt-4 w-20" class-field="!bg-slate-800 !text-white" pattern="\d*"
                                      v-bind:label="__('Vásárlónként')"
                                      v-bind:max="product.base[`${group}`].wednesday.total"
                                      v-bind:min="1"
                                      v-bind:name="product.id + '.' + group + '.wednesday.perPerson'"
                                      v-bind:step="1"
                                      v-model.number="product.base[`${group}`].wednesday.perPerson"
                                      v-on:update:model-value="checkMaxPerPerson(product, group, 'wednesday')"
                    />
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 xl:col-span-1 xl:flex"
                      v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'thursday' }"
                >
                    <c-control-number class="w-20" class-field="!bg-slate-800 !text-white" pattern="\d*"
                                      v-bind:label="__('Összesen')"
                                      v-bind:min="1"
                                      v-bind:name="product.id + '.' + group + '.thursday.total'"
                                      v-bind:step="1"
                                      v-model.number="product.base[`${group}`].thursday.total"
                                      v-on:update:model-value="updateTotalAvailability(product, group, 'thursday')"
                    />
                    <c-control-number class="mt-4 w-20" class-field="!bg-slate-800 !text-white" pattern="\d*"
                                      v-bind:label="__('Vásárlónként')"
                                      v-bind:max="product.base[`${group}`].thursday.total"
                                      v-bind:min="1"
                                      v-bind:name="product.id + '.' + group + '.thursday.perPerson'"
                                      v-bind:step="1"
                                      v-model.number="product.base[`${group}`].thursday.perPerson"
                                      v-on:update:model-value="checkMaxPerPerson(product, group, 'thursday')"
                    />
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 xl:col-span-1 xl:flex"
                      v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'friday' }"
                >
                    <c-control-number class="w-20" class-field="!bg-slate-800 !text-white" pattern="\d*"
                                      v-bind:label="__('Összesen')"
                                      v-bind:min="1"
                                      v-bind:name="product.id + '.' + group + '.friday.total'"
                                      v-bind:step="1"
                                      v-model.number="product.base[`${group}`].friday.total"
                                      v-on:update:model-value="updateTotalAvailability(product, group, 'friday')"
                    />
                    <c-control-number class="mt-4 w-20" class-field="!bg-slate-800 !text-white" pattern="\d*"
                                      v-bind:label="__('Vásárlónként')"
                                      v-bind:max="product.base[`${group}`].friday.total"
                                      v-bind:min="1"
                                      v-bind:name="product.id + '.' + group + '.friday.perPerson'"
                                      v-bind:step="1"
                                      v-model.number="product.base[`${group}`].friday.perPerson"
                                      v-on:update:model-value="checkMaxPerPerson(product, group, 'friday')"
                    />
                </span>
            </div>
        </div>
    </div>

    <c-button class="bg-slate-800 border-2 border-slate-800 font-semibold hover:bg-highlight hover:border-highlight mb-4 mt-8 mx-auto normal-case px-4 py-2 rounded-none table text-center !text-lg text-white transition-colors w-48"
              v-on:click="submit"
    >
        {{ __('Mentés') }}
    </c-button>

    <div class="mt-8 mx-auto px-2 w-full">
        <div class="bg-highlight flex flex-col mb-8 p-4 text-white">
            <span class="font-bold mb-4 text-lg">{{ __('Veszélyzóna') }}!</span>

            <div class="gap-4 grid grid-cols-2 lg:grid-cols-4">
                <a class="bg-white cursor-pointer duration-500 hover:bg-success hover:text-white px-2 py-1 table text-center text-slate-800 text-sm transition-colors w-full"
                   v-on:click="generateAvailabilityFromBasePlan(0, 0)"
                >
                    <span class="block">
                        {{ __('Másolás erre a hétre') }}
                    </span>
                    <span class="text-xs">({{ __('Összes csoport') }})</span>
                </a>

                <a class="bg-white cursor-pointer duration-500 hover:bg-success hover:text-white px-2 py-1 table text-center text-slate-800 text-sm transition-colors w-full"
                   v-on:click="generateAvailabilityFromBasePlan(1, 4)"
                >
                    <span class="block">
                        {{ __('Másolás a következő 4 hétre') }}
                    </span>
                    <span class="text-xs">({{ __('Összes csoport') }})</span>
                </a>

                <a class="bg-slate-800 cursor-pointer duration-500 hover:bg-warning hover:text-slate-800 px-2 py-1 table text-center text-sm text-white transition-colors w-full"
                   v-on:click="generateAvailabilityFromBasePlan(0, 0, true)"
                >
                    <span class="block">
                        {{ __('Felülírás erre a hétre') }}
                    </span>
                    <span class="text-xs">({{ __('Összes csoport') }})</span>
                </a>

                <a class="bg-slate-800 cursor-pointer duration-500 hover:bg-warning hover:text-slate-800 px-2 py-1 table text-center text-sm text-white transition-colors w-full"
                   v-on:click="generateAvailabilityFromBasePlan(1, 4, true)"
                >
                    <span class="block">
                        {{ __('Felülírás a következő 4 hétre') }}
                    </span>
                    <span class="text-xs">({{ __('Összes csoport') }})</span>
                </a>
            </div>
        </div>
    </div>

    <div class="bottom-2 fixed flex items-center right-2 z-20">
        <a class="bg-success block border border-white cursor-pointer mr-2 p-2 rounded-full shadow-lg"
           v-on:click="submit"
        >
            <c-icon class="h-8 stroke-white w-8" icon="save" />
        </a>
        <a class="bg-slate-800 block border border-white cursor-pointer p-2 rounded-full shadow-lg"
           v-on:click="scrollToTop"
        >
            <c-icon class="h-8 stroke-white w-8" icon="chevron-up" />
        </a>
    </div>
</template>

<script setup lang="ts">
    import { computed, inject, onMounted, ref } from 'vue';
    import {
        CButton,
        CControlNumber,
        CControlSelect,
        CIcon,
    } from '@teamfurther/cinderblock';
    import { DateTime } from 'luxon';
    import ProductRepository from '../../repositories/ProductRepository';
    import UserGroupRepository from '../../repositories/UserGroupRepository';
    import { useCurrencyStore } from '../../stores/currency';
    import { useRequestStore } from '../../stores/request';

    const __ = inject('__');
    const currencyStore = useCurrencyStore();
    const currentDate = ref(DateTime.now().setLocale('en'));
    const group = ref();
    const groupLabel = computed(() => groups.value.find((g) => g.value === group.value).label);
    const groupBase = ref(null);
    const groups = ref([]);
    const groupsExceptCurrent = computed(() => groups.value.filter((g) => g.value !== group.value));
    const productRepository = new ProductRepository();
    const products = ref();
    const requestStore = useRequestStore();
    const userGroupRepository = new UserGroupRepository();

    function addMissingAvailabilityData() {
        products.value.forEach((product) => {
            if (!product.quantity) {
                product.quantity = {};
            }

            groups.value.forEach((group) => {
                if (!product.base[`${group.value}`]) {
                    product.base[`${group.value}`] = {};
                }

                product.base[`${group.value}`] = {
                    monday: product.base[`${group.value}`]?.monday ?? { perPerson: null, total: null },
                    tuesday: product.base[`${group.value}`]?.tuesday ?? { perPerson: null, total: null },
                    wednesday: product.base[`${group.value}`]?.wednesday ?? { perPerson: null, total: null },
                    thursday: product.base[`${group.value}`]?.thursday ?? { perPerson: null, total: null },
                    friday: product.base[`${group.value}`]?.friday ?? { perPerson: null, total: null },
                };
            });
        });
    }

    function checkMaxPerPerson(product, group, day) {
        console.log('here');
        if (product.base[`${group}`][day].perPerson > product.base[`${group}`][day].total) {
            console.log('here 2');
            product.base[`${group}`][day].perPerson = product.base[`${group}`][day].total;
        }
    }

    function copyFromBase() {
        if (!groupBase.value) {
            return;
        }

        products.value.forEach((product) => {
            if (product.base[`${groupBase.value}`]) {
                product.base[`${group.value}`] = { ...product.base[`${groupBase.value}`] };
            } else {
                product.base[`${group.value}`] = {
                    monday: { perPerson: null, total: null },
                    tuesday: { perPerson: null, total: null },
                    wednesday: { perPerson: null, total: null },
                    thursday: { perPerson: null, total: null },
                    friday: { perPerson: null, total: null },
                };
            }
        });

        addMissingAvailabilityData();

        groupBase.value = null;
    }

    function generateAvailabilityFromBasePlan(start, total, override = false) {
        new Promise((resolve, reject) => {
            requestStore.put('products/availability-from-base', {
                start: start,
                override: override,
                total: total,
            })
                .then((response : any) => {
                    requestStore.message = __('Termékek elérhetősége sikeresen frissítve.');
                    requestStore.status = 200;
                    requestStore.title = __('Siker');

                    resolve(response.data);
                })
                .catch(error => reject(error));
        });
    }

    async function getProducts() {
        products.value = await productRepository.index({
            filters: {
                active: true,
            },
        });

        addMissingAvailabilityData();
    }

    function nextDay() {
        currentDate.value = currentDate.value.plus({ days: 1 });

        if (currentDate.value.weekday === 6) {
            currentDate.value = currentDate.value.plus({ day: 2 });
        }

        addMissingAvailabilityData();
    }

    function prevDay() {
        currentDate.value = currentDate.value.minus({ days: 1 });

        if (currentDate.value.weekday === 7) {
            currentDate.value = currentDate.value.minus({ day: 2 });
        }

        addMissingAvailabilityData();
    }

    function resetAvailabilityData(day) {
        products.value.forEach((product) => {
            groups.value.forEach((group) => {
                product.base[`${group.value}`][day].perPerson = 0;
                product.base[`${group.value}`][day].total = 0;
            });
        });
    }

    function scrollToTop() {
        window.scrollTo({
            behavior: 'smooth',
            top: 0,
        });
    }

    async function submit() {
        const payload: Record<string, any> = {};

        for (const product of products.value) {
            payload[product.id] = product.base;
        }

        if (Object.keys(payload).length > 0) {
            await requestStore.put('products/base', { products: payload });
        }

        requestStore.message = __('Termékek elérhetősége sikeresen frissítve.');
        requestStore.status = 200;
        requestStore.title = __('Siker');
    }

    function updateTotalAvailability(product, group, day) {
        groups.value.forEach((g) => {
            if (g.value === group) {
                return;
            }

            product.base[g.value][day].total = product.base[group][day].total;
        });
    }

    onMounted(async () => {
        const userGroups = await userGroupRepository.index({
            filters: {
                active: true,
            },
        });
        userGroups.forEach((g) => {
            groups.value.push({
                label: g.name,
                value: g.id,
            });

            if (g.name === 'Általános') {
                group.value = g.id;
            }
        });

        await getProducts();

        if (currentDate.value.weekday === 6) {
            currentDate.value = currentDate.value.plus({ day: 2 });
        } else if (currentDate.value.weekday === 7) {
            currentDate.value = currentDate.value.plus({ day: 1 });
        }
    });
</script>
